// Вкладка «Задачи» менеджера по преподавателям: задача «Плохой отзыв» (Антон 16.10, карточка одобрена; макет tasks-v4).
// Оценка ученика 1–3 (кроме чисто технической причины) → карточка: контекст, итог менеджера. Данные раз в сутки — GET /api/bad-reviews.
import { useState, useEffect, useCallback } from 'react'
import api from '../api'

const MONTHS = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря']
const dayHuman = (iso) => { if (!iso) return ''; const [, m, d] = iso.slice(0, 10).split('-'); return Number(d) + ' ' + (MONTHS[Number(m) - 1] || m) }
const stamp = (s) => { if (!s) return ''; return dayHuman(s) + ' в ' + s.slice(11, 16) }

function Stars({ n }) {
  return (
    <span>
      <span style={{ color: '#F59E0B', letterSpacing: 1 }}>{'★'.repeat(n)}</span>
      <span style={{ color: '#CBD5E1', letterSpacing: 1 }}>{'★'.repeat(5 - n)}</span> {n} из 5
    </span>
  )
}
function Row({ k, children }) {
  return (
    <div className="flex gap-3 py-1.5 border-b border-slate-100 last:border-0 text-[13px]">
      <span className="w-44 shrink-0 text-slate-400">{k}</span>
      <span className="font-medium text-slate-800">{children}</span>
    </div>
  )
}

export default function BadReviewsTab({ onOpenCalls }) {
  const [data, setData] = useState(null)
  const [scope, setScope] = useState('all')
  const [i, setI] = useState(0)
  const [busy, setBusy] = useState(false)
  const [note, setNote] = useState('')
  const [err, setErr] = useState('')

  const load = useCallback(() => {
    return api.get('/api/bad-reviews', { params: { scope } }).then((r) => { setData(r.data); setErr('') })
      .catch((e) => setErr((e.response && e.response.data && e.response.data.error) || e.message))
  }, [scope])
  useEffect(() => { setI(0); load() }, [load])

  const open = (data && data.open) || []
  const done = (data && data.done) || []
  const t = open[Math.min(i, Math.max(0, open.length - 1))]

  const finish = async (outcome, goCalls) => {
    if (!t || busy) return
    if (outcome === 'unfounded' && !window.confirm('Отметить отзыв как необоснованный? Задача закроется.')) return
    setBusy(true)
    try {
      await api.post('/api/bad-reviews/' + t.id + '/result', { outcome, note })
      setNote(''); await load(); setI(0)
      if (goCalls && onOpenCalls) onOpenCalls()
    } catch (e) { alert((e.response && e.response.data && e.response.data.error) || e.message) }
    setBusy(false)
  }

  return (
    <div className="max-w-[760px] mx-auto px-4 py-5">
      <div className="flex items-center gap-3 mb-3 flex-wrap">
        <div>
          <div className="text-[17px] font-extrabold">Задачи</div>
          <div className="text-[12.5px] text-slate-400">Плохие отзывы учеников: оценка 1–3, кроме «Плохая связь или техника»</div>
        </div>
        <div className="ml-auto flex gap-1.5">
          {[['mine', 'Мои'], ['all', 'Все']].map(([k, l]) => (
            <button key={k} onClick={() => setScope(k)}
              className={'px-3 py-1.5 rounded-lg text-[12.5px] font-bold border ' + (scope === k ? 'bg-sky-600 text-white border-sky-600' : 'bg-white text-slate-600 border-slate-200')}>
              {l}{data ? ' ' + (k === 'mine' ? data.counts.mine : data.counts.open) : ''}
            </button>
          ))}
        </div>
      </div>

      {err && <div className="text-[13px] text-red-600 bg-red-50 border border-red-200 rounded-xl p-3 mb-3">{err}</div>}
      {!data && !err && <div className="text-[13px] text-slate-400">Загрузка…</div>}
      {data && !open.length && <div className="bg-white border border-slate-200 rounded-2xl p-6 text-center text-[13.5px] text-slate-500">Новых плохих отзывов нет</div>}

      {t && (
        <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
          <div className="flex items-center gap-3 p-4 border-b border-slate-100">
            <div className="w-10 h-10 rounded-xl bg-slate-100 flex items-center justify-center font-extrabold text-slate-500">{(t.teacher_name || '?').slice(0, 1)}</div>
            <div className="min-w-0">
              <b className="text-[14.5px]">{t.teacher_name}</b>
              <div className="text-[12px] text-slate-400">Плохой отзыв · {stamp(t.rated_at)}{t.assigned_name ? ' · ответственный: ' + t.assigned_name : ''}</div>
            </div>
            <div className="ml-auto text-[11.5px] text-slate-400 text-right shrink-0">
              Очередь<br />{Math.min(i, open.length - 1) + 1} из {open.length}
              <div className="flex gap-1 mt-1 justify-end">
                <button disabled={i <= 0} onClick={() => setI(i - 1)} className="px-2 rounded border border-slate-200 disabled:opacity-30">‹</button>
                <button disabled={i >= open.length - 1} onClick={() => setI(i + 1)} className="px-2 rounded border border-slate-200 disabled:opacity-30">›</button>
              </div>
            </div>
          </div>
          <div className="px-4 py-2 text-[12.5px] font-bold text-red-700 bg-red-50 border-b border-red-100">Плохой отзыв · оценка {t.rating} из 5</div>
          <div className="p-4">
            <div className="rounded-xl border border-slate-200 p-3">
              <div className="text-[12px] font-extrabold text-slate-500 mb-1">Контекст</div>
              <Row k="Оценка ученика"><Stars n={t.rating} /></Row>
              <Row k="Причины">{(t.reasons && t.reasons.length) ? t.reasons.join(', ') : 'не указаны'}</Row>
              {t.comment && <Row k="Сообщение ученика">«{t.comment}»</Row>}
              {t.subject && <Row k="Предмет">{t.subject}</Row>}
              {t.student_name && <Row k="Ученик">{t.student_name}</Row>}
              {t.lesson_date && <Row k="Урок">{dayHuman(t.lesson_date)}{t.lesson_time ? ', ' + t.lesson_time : ''}</Row>}
              <Row k="Рейтинг преподавателя">{t.stats.avg != null ? t.stats.avg + ' · ' + t.stats.n + ' отзывов' : 'пока нет оценок'}</Row>
              <Row k="Плохих отзывов за 30 дней"><span style={{ color: t.stats.bad30 >= 2 ? '#B91C1C' : undefined }}>{t.stats.bad30}</span></Row>
            </div>
            <textarea value={note} onChange={(e) => setNote(e.target.value)} placeholder="Заметка к итогу (по желанию)"
              className="w-full mt-3 border border-slate-200 rounded-xl p-2.5 text-[13px] min-h-[56px]" />
            <div className="text-[12px] font-extrabold text-slate-400 uppercase tracking-wide mt-3 mb-1.5">Итог</div>
            <div className="flex gap-2 flex-wrap">
              <button disabled={busy} onClick={() => finish('talked')} className="px-3.5 py-2 rounded-xl text-[13px] font-bold bg-emerald-600 text-white disabled:opacity-50">✓ Поговорил с преподавателем</button>
              <button disabled={busy} onClick={() => finish('invite', true)} className="px-3.5 py-2 rounded-xl text-[13px] font-bold bg-white border border-slate-200 text-slate-700 disabled:opacity-50">Позвать на созвон</button>
              <button disabled={busy} onClick={() => { if (onOpenCalls) onOpenCalls() }} className="px-3.5 py-2 rounded-xl text-[13px] font-bold bg-white border border-slate-200 text-slate-700">Открыть карточку</button>
              <button disabled={busy} onClick={() => finish('unfounded')} className="px-3.5 py-2 rounded-xl text-[13px] font-bold bg-white border border-red-200 text-red-700 disabled:opacity-50">✗ Отзыв необоснован</button>
            </div>
          </div>
        </div>
      )}

      {done.length > 0 && (
        <div className="mt-5">
          <div className="text-[12.5px] font-bold text-slate-400 mb-1.5">Недавно закрытые</div>
          <div className="bg-white border border-slate-200 rounded-2xl divide-y divide-slate-100">
            {done.map((d) => (
              <div key={d.id} className="px-3.5 py-2.5 text-[12.5px] flex gap-2 flex-wrap">
                <b>{d.teacher_name}</b><span className="text-slate-400">оценка {d.rating}</span>
                <span className="text-emerald-700 font-semibold">{d.outcomeLabel}</span>
                <span className="text-slate-400 ml-auto">{d.resolved_by}, {stamp(d.resolved_at)}</span>
                {d.outcome_note && <div className="w-full text-slate-500">{d.outcome_note}</div>}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
